export const rolesMapping = {
    contratos: ['contratos'],
    clientes: ['clientes'],
    colaboradores: ['colaboradores'],
    comissao: ['comissoes'],
    admin: ['admin'],
    configdespesas: ['configdespesas'],
    balancofinanceiro: ['balancofinanceiro'],
    despesas: ['despesas']
};